import { HIDE_TOAST, SHOW_TOAST } from "../../constants/action-types";
import { TOAST_TYPE } from "../../constants/toast";

export const toastInitialState = {
  isOpen: false,
  type: TOAST_TYPE.success,
  messageKey: "",
  messageVariables: {},
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case SHOW_TOAST: {
      return {
        ...state,
        isOpen: true,
        type: payload.type,
        messageKey: payload.messageKey,
        messageVariables: payload.variables,
      };
    }

    case HIDE_TOAST: {
      return {
        ...state,
        isOpen: false,
      };
    }

    default:
      return state;
  }
};
